import { Line, mixins } from 'vue-chartjs'

export default {
  extends: Line,
  props: {
    chart_labels: Array,
    chart_datasets: Array,
    chart_options: Array
  },
  mounted () {
    this.render_chart_wrapper();
  },
  methods: {
    render_chart_wrapper(){
      console.log("weight rechart");
      console.log(this.chart_labels);
      console.log(this.chart_datasets);
      this.renderChart({
        labels: this.chart_labels,
        datasets: this.chart_datasets,
      }, jQuery.extend(true, {
        responsive: true,
        maintainAspectRatio: false,
        legend: {
          display: false,
        },
        scales: {
          yAxes: [{
            gridLines: {
              display: false,
            },
          }],
          xAxes: [{
            gridLines: {
              display: false,
            },
          }],
        },
        plugins: {
          datalabels: {
            display: false,
          },
        },
        elements: {
          line: {
            tension: 0,
          },
        },
      }, this.chart_options));
    },
  },
  watch: {
    chart_labels: function(){
      this.$data._chart.destroy();
      this.render_chart_wrapper();
      this.$data._chart.update();
    },
    chart_datasets: function(){
      this.$data._chart.destroy();
      this.render_chart_wrapper();
      this.$data._chart.update();
    }
  },
}
